// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__popup_container-JBC1Ec {
  flex-direction: column;
  display: flex;
  position: relative;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__popup_container-JBC1Ec .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__nano-KaXKKg {
  pointer-events: none;
  align-self: stretch;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__popup_container-JBC1Ec .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__nano-KaXKKg .semi-portal-inner {
  left: 50% !important;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__tooltip-zcXuwO.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__top-level-RYXApN {
  word-break: break-word;
  background: var(--light-color-grey-grey-7, #41414c);
  max-width: 400px;
  color: var(--light-usage-bg-color-bg-0, #fff);
  border-radius: 6px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__tooltip-zcXuwO > svg > path {
  fill: var(--light-color-grey-grey-7, #41414c);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup_container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__popup_container-JBC1Ec`,
	"popupContainer": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__popup_container-JBC1Ec`,
	"nano": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__nano-KaXKKg`,
	"tooltip": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__tooltip-zcXuwO`,
	"top-level": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__top-level-RYXApN`,
	"topLevel": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-auto-size-tooltip-index-module__top-level-RYXApN`
};
export default ___CSS_LOADER_EXPORT___;
